import React from 'react';
import { Globe2, FileCheck, Award, Leaf, ShoppingBag, MapPin } from 'lucide-react';

const services = [
  {
    id: 1,
    icon: FileCheck,
    title: 'IEC Licensing',
    description: 'Complete assistance for Import Export Code registration and renewal.',
  },
  {
    id: 2,
    icon: Award,
    title: 'APEDA Registration',
    description: 'Agricultural and Processed Food Products Export Development Authority registration services.',
  },
  {
    id: 3,
    icon: Leaf,
    title: 'FSSAI Licensing',
    description: 'Food Safety and Standards Authority of India licensing and compliance.',
  },
  {
    id: 4,
    icon: Award,
    title: 'Spices Board Registration',
    description: 'Complete registration with Spices Board of India for spice exports.',
  },
  {
    id: 5,
    icon: ShoppingBag,
    title: 'Product Sourcing',
    description: 'Global product sourcing and quality assurance services.',
  },
  {
    id: 6,
    icon: MapPin,
    title: 'Export Documentation',
    description: 'Complete documentation support for international trade.',
  },
];

export const ExportConsultancy = () => {
  return (
    <section
      id="consultancy"
      className="py-24 md:py-32 px-6 md:px-12 bg-navy relative overflow-hidden"
      data-testid="consultancy-section"
    >
      {/* Decorative Globe Background */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-5">
        <Globe2 size={600} className="text-gold" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-gold/30 rounded-full mb-6">
            <Globe2 size={20} className="text-gold" />
            <span className="text-gold uppercase tracking-widest text-sm font-semibold">Export Consultancy</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
            <span className="text-gold-gradient">Global Trade</span> Consultancy
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Expert guidance for all your export licensing, registration, and compliance needs.
          </p>
          <div className="section-divider mt-8" />
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={service.id}
                className="glass-panel p-8 rounded-lg hover-lift group opacity-0 animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'forwards' }}
                data-testid={`consultancy-card-${service.id}`}
              >
                {/* Icon with Globe Background */}
                <div className="relative mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 border border-gold/30 group-hover:bg-gold/20 transition-colors">
                    <Icon size={32} className="text-gold" />
                  </div>
                  <div className="absolute -top-2 -right-2 opacity-20">
                    <Globe2 size={40} className="text-gold" />
                  </div>
                </div>

                <h3 className="text-xl font-heading font-semibold text-white mb-3 group-hover:text-gold transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-300 leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="glass-panel p-12 rounded-lg text-center">
          <h3 className="text-2xl md:text-3xl font-heading font-semibold text-gold-gradient mb-4">
            Ready to Start Your Export Journey?
          </h3>
          <p className="text-gray-300 max-w-2xl mx-auto mb-6">
            We provide end-to-end consultancy services to help you navigate the complexities of international trade.
            Let us handle the paperwork while you focus on growing your business.
          </p>
        </div>
      </div>
    </section>
  );
};
